var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-input"},[_c('el-input',_vm._b({on:{"input":_vm.onInput},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},'el-input',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }